import React from "react";
import classNames from "classnames";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Router from "next/router";
import { AUTO_HIDE_DURATION, JOB_POST_RESET_CLICKED } from "../../services/constants";
import {
  hideSnackBar,
  hideSuccessnackBar,
  hideGenericSnackBar
} from "./snackbarActions";
import { deleteLocalStorage } from "../../services/utils";
import LogService from "services/LogService";

const styles = theme => ({
  success: {
    backgroundColor: "#ECFCEA",
    color: "#009688",
    borderRadius: "4px",
    fontWeight: 700,
    display: "flex",
    justifyContent: "center"
  },
  error: {
    color: "#FF5D56",
    backgroundColor: "#FFD3D1",
    borderRadius: "4px",
    fontWeight: 700
  },
  generic: {
    height: "44px",
    background: "#2A2F37",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center"
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: "10px"
  },
  message: {
    display: "flex",
    alignItems: "center"
  },
  resetBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginLeft: "50px",
    alignItems: "center",
    cursor: "pointer",
    ["@media (max-width:576px)"]: {
      marginLeft: "20px"
    }
  },
  undo: {
    textDecoration: "underline",
    marginLeft: "10px",
    cursor: "pointer"
  }
});

const Index = props => {
  const {
    classes,
    hideSnackBar,
    hideSuccessnackBar,
    hideGenericSnackBar,
    snackbar
  } = props;
  const handleReset = () => {
    LogService.log(JOB_POST_RESET_CLICKED)
    deleteLocalStorage();
    hideSuccessnackBar();
    Router.reload(window.location.pathname);
  };
  const {
    snackBarState,
    snackBarMsg,
    snackBarSuccessState,
    snackBarSuccessMsg,
    snackBarGenericState,
    snackBarGenericMsg,
    isUndo,
    undoOnclick,
    isReset
  } = snackbar;

  const handleUndoClick = () => {
    hideSuccessnackBar();
    undoOnclick();
  };

  return (
    <div id="snackbar-container">
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={snackBarState}
        autoHideDuration={AUTO_HIDE_DURATION}
        onClose={hideSnackBar}
      >
        <SnackbarContent
          className={classes.error}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              <ErrorIcon
                className={classNames(classes.icon, classes.iconVariant)}
              />
              {snackBarMsg}
            </span>
          }
        />
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={snackBarSuccessState}
        autoHideDuration={AUTO_HIDE_DURATION}
        onClose={hideSuccessnackBar}
      >
        <SnackbarContent
          className={classes.success}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              <CheckCircleIcon
                className={classNames(classes.icon, classes.iconVariant)}
              />
              {snackBarSuccessMsg}
              {isUndo ? (
                <div onClick={handleUndoClick} className={classes.undo}>
                  Undo
                </div>
              ) : null}
              {isReset ? (
                <div className={classes.resetBtn} onClick={handleReset}>
                  <img
                    src="/hire/loader.png"
                    width="16"
                    height="16"
                    alt="loader"
                  />{" "}
                  RESET
                </div>
              ) : null}
            </span>
          }
        />
      </Snackbar>

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={snackBarGenericState}
        autoHideDuration={AUTO_HIDE_DURATION}
        onClose={hideGenericSnackBar}
      >
        <SnackbarContent
          className={classes.generic}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              {snackBarGenericMsg}
            </span>
          }
        />
      </Snackbar>
    </div>
  );
};

const mapStateToProps = state => ({
  snackbar: state.snackbarReducer
});

export default connect(mapStateToProps, {
  hideSnackBar,
  hideSuccessnackBar,
  hideGenericSnackBar
})(withStyles(styles)(Index));
